import type { Transaction } from "@/api/types";

/** Valor com sinal de um lançamento para totais do dia: receita +, despesa −, transferência não conta. */
export function signedForDay(t: Transaction): number {
  if (t.type === "income") return t.amountMinor;
  if (t.type === "expense") return -t.amountMinor;
  return 0;
}

/**
 * Agrupa lançamentos (já ordenados por data desc) por dia, mantendo a ordem. O total do dia é por moeda (nunca soma
 * moedas diferentes) e cobre o que está carregado — completa-se quando a próxima página traz o resto do dia.
 */
export function groupByDay(items: Transaction[]) {
  const groups: Array<{ date: string; items: Transaction[]; totals: Map<string, number> }> = [];
  for (const t of items) {
    let g = groups.at(-1);
    if (!g || g.date !== t.date) {
      g = { date: t.date, items: [], totals: new Map() };
      groups.push(g);
    }
    g.items.push(t);
    if (t.type !== "transfer") g.totals.set(t.currency, (g.totals.get(t.currency) ?? 0) + signedForDay(t));
  }
  return groups;
}
